import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
// @mui
import { Box, Card, Link, Typography, Stack, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
import { fCurrency } from '../../../utils/formatNumber';
// components
import Label from '../../../components/label';
import { ColorPreview } from '../../../components/color-utils';
// ----------------------------------------------------------------------
import { apiUrl } from '../../../utils/api';
import { useNavigate } from 'react-router-dom';
import FoodDeital from '../../../pages/sellerInfo/foodDeital/FoodDeital';

const StyledProductImg = styled('img')({
  top: 0,
  width: '70',
  height: '200%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

ShopProductCard.propTypes = {
  product: PropTypes.object,
};
const DataLogo = ({ name, path, setFoodDetail, foodId }) => {
  const url = `${apiUrl.foodImg}${path}`;
  return (
    <StyledProductImg alt={name} src={url} sx={{ width: "100%", height: "100%" }} onClick={() => { setFoodDetail(foodId) }} />

  )
}


export default function ShopProductCard({ product, onOpen, onDelete, foodId, load, reLoad }) {
  const { name, thumbnail, status } = product;

  const navigate = useNavigate();
  const [foodDetail, setFoodDetail] = useState(null)

  return (
    <>
      <Card >
        <Box sx={{ pt: '100%', position: 'relative' }} >
          {status && (
            <Label
              variant="filled"
              color={(status === 'sale' && 'error') || 'info'}
              sx={{
                zIndex: 9,
                top: 16,
                right: 16,
                position: 'absolute',
                textTransform: 'uppercase',
              }}
            >
              {status}
            </Label>
          )}

          {/* < alt={name} src={image} /> */}
          <DataLogo path={thumbnail} setFoodDetail={setFoodDetail} foodId={foodId} />
        </Box>

        <Stack spacing={2} sx={{ p: 3 }}>
          <Link color="inherit" underline="hover">
            <Typography variant="subtitle2" noWrap>
              {name}
            </Typography>
          </Link>

          {/* <Stack direction="row" alignItems="center" justifyContent="space-between">
            <ColorPreview colors={colors} />
            <Typography variant="subtitle1">
              <Typography
                component="span"
                variant="body1"
                sx={{
                  color: 'text.disabled',
                  textDecoration: 'line-through',
                }}
              >
                {priceSale && fCurrency(priceSale)}
              </Typography>
              &nbsp;
              {fCurrency(price)}
            </Typography>

          </Stack> */}
          <Stack direction="row" spacing={2} >

            <Button variant='contained' onClick={() => { onOpen(product) }}>Edit</Button>
            <Button variant='contained' color='error' onClick={() => { onDelete(product) }}>Delete</Button>
          </Stack>
        </Stack>
      </Card>
      {/* Pagination controls */}
      <FoodDeital foodDetail={foodDetail} setFoodDetail={setFoodDetail} foodID={foodId} load={load} reLoad={reLoad} />
    </>
  );
}
